import React from "react";
import { Badge } from "reactstrap";
import "./chip.scss";

class CustomChip extends React.Component {
  state = {
    device: "mobile",
  };
  componentDidMount() {
    this.setState({
      device: window.screen.availWidth < 850 ? "mobile" : "web",
    });
  }
  render() {
    return (
      <Badge
        className={"custom-chip " + (this.props.checked ? " active " : "")}
        onClick={(e) => this.props.onChecked(!this.props.checked)}
        color="primary"
      >
        {this.props.checked && (
          <i class={"fas  fa-sm " + this.props.iconClass}></i>
        )}{" "}
        {this.props.title}
      </Badge>
    );
  }
}

export default CustomChip;
